"use client";
import { useEffect, useRef } from "react";
import { isElementVisible } from "@/lib/utils";
import { generalEcomEvent } from "@/lib/utils";

const GtmViewList = () => {
    const scrollTimer = useRef();
    useEffect(() => {
  
      const handleScroll = (e) => {
          clearTimeout(scrollTimer.current);
          scrollTimer.current  = setTimeout(() => {
              const visibleElements = document.querySelectorAll(".catalog-products:not(.viewed)");
              visibleElements.forEach(node => {
                  const isVisible = isElementVisible(node);
                  if(isVisible){
                      node.classList.add('viewed');
                      if(node.dataset){
                        const nodeImg = node.querySelector('img');
                        generalEcomEvent({ 
                            event: "view_item_list",
                            other: {
                              currency: "INR",
                              value: node.dataset.price,
                            },
                            items: [{
                                item_id: node.dataset.pk,
                                item_name: node.dataset.name,
                                item_category: node.dataset.category,
                                price: node.dataset.price,
                                item_brand: "ORNAZ",
                                item_img: nodeImg ? nodeImg.getAttribute("src"): null,
                            }]
                        })
                      }
                  }
              })
          }, 500)
      }
  
      document.addEventListener("scroll", handleScroll, { passive: true })
      return () => {
        document.removeEventListener('scroll', handleScroll, { passive: true })
        clearTimeout(scrollTimer.current);
      }
    }, [])
    return null
}

export default GtmViewList